import { BENCHMARKS_SERVICE_HOSTS } from './config';
import {
  getGetRequestInit,
  getPostRequestInit,
  getProxyServicePath,
  retrieveData,
} from './common';
import { CommonLogger } from '../logger';

export const getBrandBenchmarks = async (benchmarksReq, token) => {
  const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);

  const url = `${serviceEndpoint}/brandBenchmarks`;

  const requestInit = getBenchmarksPostRequestInit(benchmarksReq, token);

  return await retrieveData(url, requestInit);
};

export const getCategoryBenchmarks = async (benchmarksReq, token) => {
  const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);

  const url = `${serviceEndpoint}/categoryBenchmarks`;

  const requestInit = getBenchmarksPostRequestInit(benchmarksReq, token);

  return await retrieveData(url, requestInit);
};

export const getBenchmarksFilterValues = async (
  {
    brandId,
    dimension,
    initialStart,
    initialEnd,
    comparisonStart,
    comparisonEnd,
    context,
    categoryId,
  },
  token,
) => {
  const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);

  const url = `${serviceEndpoint}/filters` +
    `?brandId=${brandId}` +
    `&dimension=${dimension}` +
    `&initialStart=${initialStart}` +
    `&initialEnd=${initialEnd}` +
    `&comparisonStart=${comparisonStart}` +
    `&comparisonEnd=${comparisonEnd}` +
    `&context=${context}` +
    `&categoryId=${categoryId}`;

  const requestInit = getGetRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const getCategories = async (token) => {
  try {
    const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);
    const url = `${serviceEndpoint}/categories`;
    const requestInit = getGetRequestInit(token);
    const response = await retrieveData(url, requestInit);

    return response;
  } catch (e) {
    CommonLogger.error('Error getting Categories for Benchmarks', { e });
  }
};

export const getSubcategories = async (token) => {
  try {
    const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);
    const url = `${serviceEndpoint}/subCategories`;
    const requestInit = getGetRequestInit(token);
    const response = await retrieveData(url, requestInit);

    return response;
  } catch (e) {
    CommonLogger.error('Error getting Subcategories for Benchmarks', { e });
  }
};

export const getBenchmarksBrands = async (userBrandIds, token) => {
  try {
    const serviceEndpoint = getProxyServicePath(BENCHMARKS_SERVICE_HOSTS);
    const url = `${serviceEndpoint}/brands`;
    const requestInit = getPostRequestInit(userBrandIds, token);
    const response = await retrieveData(url, requestInit);

    return response;
  } catch (e) {
    CommonLogger.error('Error getting Brands for Benchmarks', { e });
  }
};

const getBenchmarksPostRequestInit = (benchmarksReq, token) => {
  const postBody = getBenchmarksPostBody(benchmarksReq);

  return getPostRequestInit(postBody, token);
};

const getBenchmarksPostBody = (benchmarksReq) => {
  const {
    brandId,
    dimensions,
    filters,
    initialStart,
    initialEnd,
    comparisonStart,
    comparisonEnd,
    categoryId,
    subcategoryIds,
  } = benchmarksReq;

  return {
    brandId,
    dimensions,
    filters,
    initialPeriod: {
      start: initialStart,
      end: initialEnd,
    },
    comparisonPeriod: {
      start: comparisonStart,
      end: comparisonEnd,
    },
    categoryId,
    subcategoryIds,
  };
};
